"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTooltipList = void 0;
const react_1 = __importDefault(require("react"));
const main_1 = require("../../components/icon/main");
const styled_1 = require("./styled");
function ChartTooltipList(args) {
    const { title, values } = args;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        title && react_1.default.createElement(styled_1.StyledChartTooltipTitle, null, title),
        values && (react_1.default.createElement(styled_1.StyledChartTooltipValues, null, values.map(({ color, label, value }, i) => {
            return (react_1.default.createElement(styled_1.StyledChartTooltipValueItem, { key: i, color: color },
                color && react_1.default.createElement(main_1.Icon, { name: "chip-placeholder" }),
                react_1.default.createElement("strong", null,
                    label,
                    ": "),
                react_1.default.createElement("span", null, value)));
        })))));
}
exports.ChartTooltipList = ChartTooltipList;
//# sourceMappingURL=list.js.map